// extracted by mini-css-extract-plugin
export var title = "title__Dl6O7";
export var closeIcon = "close-icon__qxLrn";